const SERVICE = 'client';

export async function fetchApiCredentialList(app, filters) {
  const {
    rows_per_page,
    requested_page,
    sorted_columns,
    ...query
  } = filters;

  query.skip = (requested_page - 1) * rows_per_page;
  query.limit = rows_per_page;

  const sortKeys = Object.keys(filters.sorted_columns || {});

  if (sortKeys.length > 0) {
    query.sort = sortKeys.map((sortKey) => {
      const { direction } = filters.sorted_columns[sortKey];
      return [sortKey, direction.toUpperCase()];
    });
  }

  const service = app.service(SERVICE);
  const list = await service.find({ query });
  return list;
}


export async function saveApiCredential(data, app) {
  const service = app.service(SERVICE);
  const id = data.client_id;

  let res;

  if (id && id !== 'To be generated') {
    res = await service.patch(data.client_id, data);
    return res.data;
  }

  res = await service.create(data);
  return res;
}


export async function deleteApiCredential(id, app) {
  const service = app.service(SERVICE);
  const res = await service.remove(id);
  return res;
}


export async function fetchApiCredentialById(id, app) {
  const service = app.service(SERVICE);
  const res = await service.get(id);
  return res;
}
